module.exports = __webpack_public_path__ + "static/media/saythankyou.3d668c1e.png";